const en = {
    dashboard: "Dashboard",
    glossary: "Glossary",
    profile: "Profile",
    courses: "Courses",
    settings: "Settings",
    law: "Law of Supply and Demand",
    ppc: "Production Possibility Curve",
    consumer: "Consumer Choice",
    nextLesson: "Next Lesson",
    startQuiz: "Start Quiz",
    finishCourse: "Finish Course",
  };
  
  export default en;
